import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomManufacturerCampaignOverview, ManufacturerCampaignSalesNotification,ManufacturerCampaignResultsData } from './custom-manufacturer-campaign.models';

@Injectable()
export class CustomManufacturerCampaignAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  getManufacturerCampaign(productCode: string,manufacturerNumber: string, manufacturerId: string, ean: string, campaignId: string,showOldData: boolean): Observable<CustomManufacturerCampaignOverview> {
    const params = {
      productCode,
      manufacturerNumber,
      manufacturerId,
      ean,
      campaignId,
      showOldData
    };
    return this.http.get<CustomManufacturerCampaignOverview>(
      this.occEndpoints.buildUrl('customManufacturerCampaignOverview', {queryParams: params})
    );
  }

  getManufacturerCampaignDetails(campaignId: string, productCode:string) : Observable<ManufacturerCampaignSalesNotification[]> {
    const params = {
      campaignId,
      productCode
    };
    return this.http.get<ManufacturerCampaignSalesNotification[]>(
      this.occEndpoints.buildUrl('customManufacturerCampaignDetails', {queryParams: params})
    );
  }

  deleteSalesNotification(salesNotificationPkList: string[]) : Observable<boolean> {
    const params = {
      salesNotificationPkList
    };
    return this.http.delete<boolean>(
      this.occEndpoints.buildUrl('customManufacturerCampaignDetails', {queryParams: params})
    );
  }

  updateSalesNotification(salesNotifications: ManufacturerCampaignSalesNotification[]) : Observable<ManufacturerCampaignResultsData[]> {
    return this.http.post<ManufacturerCampaignResultsData[]>(
      this.occEndpoints.buildUrl('customManufacturerCampaignSalesNotificationUpdate'), salesNotifications
    );
  }

}
